import React from 'react';
import { TooltipPosition } from '@progress/kendo-react-tooltip';
import cn from 'clsx';
import { Icon } from '@components-clean/core/icons/icon';
import styles from '@components-clean/core/icons/styles.module.scss';

type Props = {
    dataTestId: string;
    className?: string;
    tooltip: string;
    isSuffix?: boolean;
    tooltipPosition?: TooltipPosition;
    defaultOpacity?: 75 | 100;
};

export const UnfilterableIcon = ({ className, tooltip, defaultOpacity = 100, ...rest }: Props) => {
    return (
        <Icon
            className={cn(className, styles.secondary, {
                [styles.opacity100]: defaultOpacity === 100,
                [styles.opacity75]: defaultOpacity === 75,
            })}
            icon={['fal', 'filter-circle-xmark']}
            title={tooltip}
            tooltipPosition="top"
            {...rest}
        />
    );
};
